import React, { useEffect, useMemo, useState } from 'react'

import BasicSection from './BasicSections/BasicSection'
import CredentialsSection from './CredentialsSection/CredentialsSection'
import ProfessorSection from './ProfessorSection/ProfessorSection'
import StudentSection from './StudentSections/StudentSection'
import { ButtonsSection } from '..'
import { ProfileFormProvider, useUser } from '../../context'
import { useProfileFormController } from '../../hooks/useProfileFormController'
import { AnyProfile } from '../../types'
import { ProfileSectionId } from '../../utilFunctions/buildProfileSection'

import { ProfileContainer } from './styles'

const ProfileView = ({
  initialProfile,
  isNewUser,
  allowRoleChange = true,
  allowEmailChange = true,
  //   onSave,
}: {
  initialProfile: AnyProfile
  isNewUser: boolean
  allowRoleChange?: boolean
  allowEmailChange?: boolean
  //   onSave: (p: AnyProfile) => Promise<void>
}) => {
  const ctrl = useProfileFormController({
    initial: initialProfile,
    isNewUser,
    // onSave,
  })
  const { onEditionMode } = useUser()
  const [showCredentials, setShowCredentials] = useState(false)
  const [activeSectionId, setActiveSectionId] = useState(
    ctrl.sections[0]?.id ?? 'basic',
  )

  // si cambian secciones (role/isNewUser), asegurás que active exista
  useMemo(() => {
    if (!ctrl.sections.some((s) => s.id === activeSectionId)) {
      setActiveSectionId(ctrl.sections[0]?.id ?? 'basic')
    }
  }, [ctrl.sections, activeSectionId])

  const renderSection = (sectionId: ProfileSectionId) => {
    switch (sectionId) {
      case 'basic':
        return (
          <BasicSection
            allowRoleChange={allowRoleChange}
            allowEmailChange={allowEmailChange}
          />
        )
      case 'studentInfo':
        return <StudentSection />
      case 'professorInfo':
      case 'adminInfo':
        return <ProfessorSection />
      case 'credentials':
        return (
          <CredentialsSection
            showCredentials={showCredentials}
            setShowCredentials={setShowCredentials}
          />
        )
      default:
        return null
    }
  }

  useEffect(() => {
    if (!onEditionMode) {
      setShowCredentials(false)
    }
  }, [onEditionMode])

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ProfileFormProvider value={ctrl as any}>
      <ProfileContainer>
        {ctrl.sections.map((section) => (
          <React.Fragment key={section.id}>
            {renderSection(section.id)}
          </React.Fragment>
        ))}
        <ButtonsSection
          showCredentials={showCredentials}
          setShowCredentials={setShowCredentials}
        />
      </ProfileContainer>
    </ProfileFormProvider>
  )
}

export default ProfileView
